// extracted by mini-css-extract-plugin
export default {"form":"default_form__jSYGg","form__controls":"default_form__controls__hF4Z3","information":"default_information__kI4lq","switch":"default_switch__YZyk6"};